import { render } from "./MainButton.vue?vue&type=template&id=077fd2a8&scoped=true"
import script from "./MainButton.vue?vue&type=script&lang=js"
export * from "./MainButton.vue?vue&type=script&lang=js"

import "./MainButton.vue?vue&type=style&index=0&id=077fd2a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077fd2a8"]])

export default __exports__